function hostnameToEnvironment(hostname: string) {
  if (hostname.includes('localhost')) {
    return 'localhost';
  } else if (hostname.includes('testing')) {
    return 'testing';
  } else if (hostname.includes('staging')) {
    return 'staging';
  } else {
    return 'production';
  }
}

export const environment = hostnameToEnvironment(window.location.hostname);
